import React from 'react'
import { Link } from 'react-router-dom'
import logoimg from "../../assets/images/logo/logo.png"

const Footer1 = () => {
    return (
        <div>
            <footer>
                <div id="footer" className="footer-main-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="footer-block">
                                    <div className="footer-logo">
                                        <Link to="/" title=""><img src={logoimg} className="img-fluid" alt="" /></Link>
                                    </div>
                                    <div className="footer-dtls">
                                        <p>Lorem ipsum dolor amet, consectetur sell adipis elit phase nibh ellentes</p>
                                    </div>
                                    <ul className="footer-social-icons">
                                        <li><Link to="https://www.facebook.com/" title="" target='_blank'><i className="flaticon-facebook"></i></Link></li>
                                        <li><Link to="https://www.twitter.com/" title="" target='_blank'><i className="flaticon-twitter"></i></Link></li>
                                        <li><Link to="https://www.linkedin.com/" title="" target='_blank'><i className="flaticon-linkedin"></i></Link></li>
                                        <li><Link to="https://www.pinterest.com/" title="" target='_blank'><i className="flaticon-pinterest"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-widget">
                                            <h3 className="footer-widget-heading">Useful Links</h3>
                                            <ul className="footer-menu">
                                                <li><Link to="/Aboutus" title="">About Us</Link></li>
                                                <li><Link to="/Team" title="">Our Team</Link></li>
                                                <li><Link to="/Blog" title="">Recent News</Link></li>
                                                <li><Link to="/Portfolio" title="">Projects</Link></li>
                                                <li><Link to="#" title="">Our All Services </Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-widget">
                                            <h3 className="footer-widget-heading">Category</h3>
                                            <ul className="footer-menu">
                                                <li><Link to="#" title="">Coordinator</Link></li>
                                                <li><Link to="#" title="">Architect</Link></li>
                                                <li><Link to="#" title="">Manager</Link></li>
                                                <li><Link to="#" title="">Producer</Link></li>
                                                <li><Link to="#" title="">Designer</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-widget">
                                            <h3 className="footer-widget-heading">Contact</h3>
                                            <ul className="footer-menu">
                                                <li><Link to="tel:332-809-8106" title="">332-809-8106</Link></li>
                                                <li><Link to="mailto:willie.jennings@example.com" title="">willie.jennings@example.com</Link></li>
                                                <li>4517 Washington Ave. Manchester, Kentucky 39495</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tiny-footer-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="footer-coyright">© Offex 2025 | All Rights Reserved</div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <ul className="tiny-footer-menu">
                                    <li><Link to="/" title="">Terms &amp; Conditions</Link></li>
                                    <li><Link to="/Privace&Policy" title="">Privacy Policy</Link></li>
                                    <li><Link to="/Contactus" title="">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer></div>
    )
}

export default Footer1